import { Fire } from 'education-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TooltipStateful } from '../../LegoTooltip/LegoTooltip';

import './prep-lessons__hot-icon.scss';

export const PrepLessonsHotIcon = () => {
    return (
        <TooltipStateful
            content={<FormattedMessage id="prepLessons.hotIcon.tooltip" />}
            direction={['top-start', 'bottom-start', 'top-end', 'bottom-end']}
            hasTail
            size="s"
            trigger={['click', 'hover']}
            view="default"
        >
            <div className="prep-lessons__hot-icon">
                <Fire />
            </div>
        </TooltipStateful>
    );
};
